var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function collectFilesAndFilterData(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
submitData, generateAttachmentUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const files = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filterData = (data) => __awaiter(this, void 0, void 0, function* () {
            for (const key of Object.keys(data)) {
                if (key === '.dataObject' && data['.dataObject']) {
                    if (data['.dataObject'].type === 'file') {
                        const entityKey = data['entityKey'];
                        files.push({
                            entityKey,
                            file: data['.dataObject'].file,
                        });
                        delete data['.dataObject'];
                        data['url'] = yield generateAttachmentUrl(entityKey);
                        return data;
                    }
                }
                if (data[key] && typeof data[key] === 'object') {
                    yield filterData(data[key]);
                }
            }
            return data;
        });
        yield filterData(submitData);
        return {
            files,
            submitData,
        };
    });
}
